// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3DPmJ","select":"Header_select__1Hnkx","clinic":"Header_clinic__2kZ4k"};